var url = 'https://api.';
var imgUrl = 'https://img.';

var currentHref = window.location.href;

if (/recette.hub-score\.com/i.test(currentHref)) {
    url += 'recette.hub-score.com/';
    imgUrl += 'recette.hub-score.com/';

} else if (/hub-score\.com/i.test(currentHref)) {
    url += 'hub-score.com/';
    imgUrl += 'hubtracking.fr/';
} else {
    url += 'hub2up.com/';
    imgUrl += 'hub2up.com/';
}

url += 'v1/';

export const hubApiUrl:string = url;
export const hubImgUrl:string = imgUrl;
export const specialClients: Object = {
  16: [],
  12: []
};



// WEBPACK FOOTER //
// ./src/app/appsettings.ts